module.exports = __webpack_public_path__ + "roboto-thinitalic-webfont.d86f126c524dbbceee83.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-thinitalic-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-thinitalic-webfont.ttf
// module chunks = styles